import { ReactNode } from 'react';
import CancellationGuide from './CancellationGuide';
import InsuranceGuide from './InsuranceGuide';
import LuggageGuide from './LuggageGuide';
import PickupReturnGuide from './PickupReturnGuide';
import QualificationGuide from './QualificationGuide';
import ShuttleGuide from './ShuttleGuide';

export type GuideTopic = {
  /** 헤더/드로어 라벨 */
  label: string;
  /** 페이지 제목(문서 타이틀/추후 메타용) */
  title: string;
  /** 본문 인포그래픽 */
  render: () => ReactNode;
};

/**
 * 이용안내 하위 6개 페이지 — 각 항목을 네이티브 인포그래픽 컴포넌트로 렌더.
 * 라우트: /guide/:topic
 */
export const GUIDE_CONTENT: Record<string, GuideTopic> = {
  insurance: {
    label: '보험안내',
    title: '보험안내',
    render: () => <InsuranceGuide />,
  },
  qualification: {
    label: '대여자격',
    title: '대여자격 안내',
    render: () => <QualificationGuide />,
  },
  shuttle: {
    label: '셔틀버스 운행',
    title: '셔틀버스 운행 안내',
    render: () => <ShuttleGuide />,
  },
  luggage: {
    label: '수하물 규정',
    title: '수하물 규정',
    render: () => <LuggageGuide />,
  },
  'pickup-return': {
    label: '차량인수/반납',
    title: '차량 인수 / 반납 안내',
    render: () => <PickupReturnGuide />,
  },
  cancellation: {
    label: '취소규정',
    title: '예약변경 및 취소 규정',
    render: () => <CancellationGuide />,
  },
};
